export default {
  namespaced: true,
  hikvision_master_accounts: {
    title: "hikvision Master Account | hikvision Master Accounts",
    name: "name",
    ip: "IP",
    app_key: "application key",
    app_secret: "application secret key",
    port: 'puerto',
    dvrs: "DVR'S",
    syncSuccess: "sync success",
    syncDvrs: "Sync DVR'S",
    admin_url: "Administration link",
    hls_url: "HLS link",
    websocket_url: "Websocket link"
  },
};
